import { CalciteP } from 'calcite-react/Elements/Elements-styled';
import React from 'react'
import { ModalController } from '../../../../common/components/Modal';
import Context from '../../../../context/Context';
import { Container } from '../../../styles/Common/listHeader';
import CalciteSearch from "calcite-react/Search";
import Search from '../Search';
import * as component from "../../../../components/util/component";
import * as reviewersUtil from "../../../base/ReviewerManagement/reviewersUtil";

// Styled Components
import { Panel } from "../../../styles/Common/panel";
import {
  ListItem,
  ListItemTitle,
  ListItemSubtitle
} from "../../../styles/Common/list";
import Items from '../Items';
import {
  List,
  AutoSizer,
  CellMeasurer,
  CellMeasurerCache,
} from "react-virtualized";


export default class AddReviewer extends React.Component {
  constructor(props) {
    super(props)
    this.cache = new CellMeasurerCache({
      fixedWidth: true,
      defaultHeight: 120,
    });
    this.state = component.newState({
      searchText: '',
      users: [],
      selectedUser: null
    })
  }

  componentDidMount() {
    this.queryUsers()
  }

  getPlanReviewers = () => {
    return this.props.planReviewers
  }

  queryUsers = (text) => {
    const hasQ = typeof text === "string" && text.length > 0
    reviewersUtil.getAllPortalUsers().then(users => {
      let list = []
      if (!hasQ) list = users
      else {
        const lc = text.toLowerCase()
        users.forEach(user => {
          const username = user.username
          const lcUsername = username && username.toLowerCase()
          const fullName = user.firstName + " " + user.lastName
          const lcFullName = fullName && fullName.toLowerCase()
          if (lcUsername.includes(lc) || lcFullName.includes(lc)) {
            list.unshift(user)
          }
        })
      }
      list.sort((a, b) => (a.fullName.toLowerCase() > b.fullName.toLowerCase()) ? 1 : -1)
      this.setState({
        users: list
      })
    }).catch(e => {
      console.error("Problem getting portal users", e)
      this.setState({
        users: []
      })
    })
  }

  searchTextChanged = (text) => {
    text = text || ''
    this.setState({
      selectedUser: null,
      searchText: ''
    })
    this.queryUsers(text)
  }

  handleSelection = (user) => {
    if (typeof this.props.onSelectionChanged === "function") this.props.onSelectionChanged(user)
    this.setState({
      selectedUser: user
    })
  }

  render() {
    const i18n = Context.instance.i18n
    const placeholder = i18n.spaceplanner.reviewers.searchPlaceholder
    return (
      <Container>
        <Panel bordered>
          <Search
            fullWidth
            minimal
            placeholder={placeholder}
            searchTextChanged={this.searchTextChanged}
            style={{marginTop: '0.1rem'}}
          />
          {this.renderUsers()}
        </Panel>
      </Container>
    );
  }

  renderUsers() {
    const users = this.state.users.map(user => {
      return this.renderUser(user)
    })
    return (
      <div style={{flexGrow: 1, maxHeight: '24rem', overflow: 'auto'}}>
        {users}
      </div>
    )
  }

  renderUser(user) {
    const fullName = user.firstName + " " + user.lastName
    const selected = user === this.state.selectedUser
    const planReviewers = this.getPlanReviewers()
    const portalUser = Context.instance.user && Context.instance.user.portalUser
    const loggedInUsername = portalUser && portalUser.username
    let isUnassigned = true
    for (let i = 0; i < planReviewers.length; i++) {
      const pr = planReviewers[i]
      if (pr.username === user.username) {
        isUnassigned = false
        break
      }
    }
    if (loggedInUsername === user.username) isUnassigned = false
    return isUnassigned ? (
      <ListItem 
        key={user.id}
        selected={selected}
        addReviewer
        onClick={() => this.handleSelection(user)}>
        <ListItemTitle>{fullName}</ListItemTitle>
        <ListItemSubtitle>{user.username}</ListItemSubtitle>
      </ListItem>
    ) : null
  }

  static showModal(props) {
    let content, controller, okButton, selected;

    const onOK = obj => {
      if (props && props.onOK) {
        props.onOK(selected);
      }
    };

    let modalProps = {
      title: props && props.title,
      showOKCancel: true,
      closeOnOK: true,
      okLabel: Context.instance.i18n.spaceplanner.reviewers.addReviewerLabel,
      onOK: onOK,
      dialogStyle: { height: "65vh", width: "35vw" }
    };
    modalProps.onMountOKButton = btn => {
      okButton = btn;
      okButton.disable();
    };

    const selectProps = {
      planReviewers: props.planReviewers,
      onSelectionChanged: (sel) => {
        if (okButton) {
          if (sel) okButton.enable()
          else okButton.disable()
        } 
        selected = sel
      }
    }

    content = <AddReviewer {...selectProps} />;
    controller = new ModalController({});
    controller.show(modalProps, content);
  }
}